import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useToast } from '@chakra-ui/react';
import { FiMail, FiArrowRight, FiSend } from 'react-icons/fi';

import {
  RegisterPage, GameBg, PageBody,
  CentreCol, RegisterCard, FieldGroup,
  SubmitBtn, CardFooter, ErrorText,
} from './RegisterStyle';

import { resetPassword } from '../../../store/auth/authSlice';

const ResetPassword = () => {
  const { t } = useTranslation();
  const toast = useToast({ position: 'top', duration: 2000, status: 'error' });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  const { register, handleSubmit, formState: { errors } } = useForm();

  return (
    <RegisterPage>
      <GameBg>
        <PageBody>
          <CentreCol>
            <RegisterCard>
              <div className="card-top-icon">
                <FiSend size={18} />
              </div>

              <h2 className="card-title">{t('pages.auth.reset_password')}</h2>
              <p className="card-subtitle">{t('pages.auth.reset_password_hint')}</p>

              <form onSubmit={handleSubmit(values => {
                dispatch(resetPassword(values)).unwrap()
                  .then(() => navigate('/login'))
                  .catch(error => {
                    toast({ description: error.errors?.[0]?.msg });
                  });
              })}>
                <FieldGroup>
                  <span className="field-label">{t('pages.auth.email')}</span>
                  <div className="field-wrap">
                    <FiMail className="field-icon" />
                    <input
                      type="email"
                      placeholder="you@email.com"
                      {...register('email', { required: t('validation.required') })}
                    />
                  </div>
                  {errors.email && <ErrorText>{errors.email.message}</ErrorText>}
                </FieldGroup>

                <SubmitBtn type="submit" disabled={auth.isLoading}>
                  {auth.isLoading
                    ? '...'
                    : <>{t('pages.auth.reset')} <FiArrowRight size={16} /></>
                  }
                </SubmitBtn>

                <CardFooter>
                  <span className="footer-text">{t('pages.auth.have_an_account')}</span>
                  <Link to="/login" className="signin-link">
                    {t('pages.auth.login')} <FiArrowRight size={12} />
                  </Link>
                </CardFooter>
              </form>
            </RegisterCard>
          </CentreCol>
        </PageBody>
      </GameBg>
    </RegisterPage>
  );
};

export default ResetPassword;
